import React from "react";

import "./Footer.css";
import { WDQMS_VERSION } from "../../utils/general";
const Footer = props => {
  return (
    <footer className="wdqms-footer">
      <span>&copy; WMO</span>
      <span>
        The designations employed and the presentation of material herein do not
        imply the expression of any opinion whatsoever on the part of the
        Secretariats of WMO or the United Nations concerning the legal status of
        any country, area or territory, or of its authorities, or concerning the
        delimitation of its borders.
      </span>
      <span>
        Version:{" "}
        <a
          href="https://confluence.ecmwf.int/display/WIGOSWT/Releases"
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* {process.env.REACT_APP_VERSION} */}
          {WDQMS_VERSION}
        </a>
      </span>
    </footer>
  );
};

export default Footer;
